define(
    'app/views/dashboard_coupon_list_view',['app/setup',
      'app/views/pagination__view'
    ],
    function (takhfifan) {

      takhfifan.dashboardCouponListView = Backbone.View.extend({

        initialize: function (options) {
          var _this = this;
          this.pagesCount = options.pagesCount;
          this.page = options.page;

          takhfifan.eventHub.on('couponsList:loadPage', function (options) {
            _this.$el.addClass('loading-view');
            window.location.replace(
                location.protocol + '//' +
                location.host +
                location.pathname +
                '?page=' + (options.page+1));
          });

          this.initiatePagination();
        },

        initiatePagination: function () {

          if (this.pagesCount > 0) {
            this.paginationView = new takhfifan.Pagination({
              el: $('.tkh-pagination'),
              count: this.getPageCount(),
              currentPage: this.page - 1,
              clickEvent: "couponsList:loadPage",
              hideAtStart: false
            });
            this.paginationView.$el.show();
          }
        },

        getPageCount: function () {
          var pageCount = this.pagesCount;
          if (!this.pagesCount || this.pagesCount===0) {
            takhfifan.eventHub.trigger('message:show', {
              msg: i18n.t('connection_error'),
              type: 'error'
            });
          }
          return pageCount;
        },
      });
    });
